import { createBrowserRouter, Outlet } from 'react-router-dom';
import { QueryClient } from '@tanstack/react-query';
import { InitialPage } from '../pages/InitialPage';
import { ChatUI } from '../pages/ChatUI';
import { ResponsesProvider } from '../context/ResponseContext';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 3000 * 10,
      refetchOnWindowFocus: false,
    },
  },
});

const router = createBrowserRouter([
  {
    path: '/',
    element: (
      <ResponsesProvider>
        <Outlet />
      </ResponsesProvider>
    ),
    children: [
      {
        path: '',
        element: <InitialPage />,
      },
      {
        path: 'bot/:botName',
        element: <ChatUI />,
      },
    ],
  },
]);

export { router, queryClient };
